module.exports = __webpack_public_path__ + "img/market.5a4343d7.jpg";